import { render, staticRenderFns } from "./notification-board.vue?vue&type=template&id=5a022d11&scoped=true&"
import script from "./notification-board.vue?vue&type=script&lang=ts&"
export * from "./notification-board.vue?vue&type=script&lang=ts&"
import style0 from "./notification-board.vue?vue&type=style&index=0&id=5a022d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a022d11",
  null
  
)

export default component.exports